import { render, staticRenderFns } from "./SocialConnectedView.vue?vue&type=template&id=5fb2b1b5&scoped=true"
import script from "./SocialConnectedView.vue?vue&type=script&lang=js"
export * from "./SocialConnectedView.vue?vue&type=script&lang=js"
import style0 from "./SocialConnectedView.vue?vue&type=style&index=0&id=5fb2b1b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2b1b5",
  null
  
)

export default component.exports